import { ImpersonationViewType } from 'constants/impersonation';
import { CurrentViewResponseType } from 'types/user';

import axios from '../config/axiosPrivate';

export const getUsers = async (params: any) => {
  const url = `/users/`;
  const response = await axios.get(url, { params });
  return response.data;
};

export const getUserManagementUsers = async (params: any) => {
  const url = `/users/management`;
  const response = await axios.get(url, { params });
  return response.data;
};

export const createUserManagementUser = async (payload: any) => {
  const url = `/users/management`;
  const response = await axios.post(url, payload);
  return response.data;
};

export const updateUserManagementUser = async (userId: number, payload: any) => {
  const url = `/users/management/${userId}`;
  const response = await axios.patch(url, payload);
  return response.data;
};

export const getUserManagementAvailableCommunities = async (params: any) => {
  const url = `/users/management/communities`;
  const response = await axios.get(url, { params });
  return response.data;
};

export const getUserManagementAvailableFeatureFlags = async () => {
  const url = `/users/management/feature-flags`;
  const response = await axios.get(url);
  return response.data;
};

export const getUserManagementBulkFeatureFlags = async (userIds: number[]) => {
  const url = `/users/management/feature-flags/bulk`;
  const response = await axios.get(url, {
    params: {
      user_ids: userIds.join(','),
    },
  });
  return response.data;
};

export const updateUserManagementBulkFeatureFlags = async (payload: any) => {
  const url = `/users/management/feature-flags/bulk`;
  const response = await axios.post(url, payload);
  return response.data;
};

export const getUserManagementUserFeatureFlags = async (userId: number) => {
  const url = `/users/management/${userId}/feature-flags`;
  const response = await axios.get(url);
  return response.data;
};

export const updateUserManagementUserFeatureFlags = async (userId: number, payload: any) => {
  const url = `/users/management/${userId}/feature-flags`;
  const response = await axios.put(url, payload);
  return response.data;
};

export const getUserInfo = async () => {
  const url = `/users/info`;
  const response = await axios.get(url);
  return response.data;
};

export const updateCurrentUserAvatar = async (avatar: File) => {
  const url = `/users/info/avatar`;
  const formData = new FormData();
  formData.append('avatar', avatar);
  const response = await axios.patch(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteCurrentUserAvatar = async () => {
  const url = `/users/info/avatar`;
  const response = await axios.delete(url);
  return response.data;
};

export const impersonateUser = async (oayload: { user_id: number | undefined }) => {
  const response = await axios.post(`users/impersonate`, oayload);
  return response.data;
};

export const setCurrentView = async (view: ImpersonationViewType) => {
  const response = await axios.post<CurrentViewResponseType>(`users/current_view`, { view });
  return response.data;
};

export const setContextCompany = async (companyId: number | undefined = undefined) => {
  const response = await axios.post(`users/context_company`, { company: companyId });
  return response.data;
};

export const getClients = async (params: any) => {
  const url = `/users/clients`;
  const response = await axios.get(url, { params });
  return response.data;
};

export const getCompanies = async (params: any) => {
  const url = `/company/`;
  const response = await axios.get(url, { params });
  return response.data;
};

export const createCompany = async (payload: any) => {
  const url = `/company/`;
  const response = await axios.post(url, payload);
  return response.data;
};

export const updateCompany = async (companyId: number, payload: any) => {
  const url = `/company/${companyId}`;
  const response = await axios.patch(url, payload);
  return response.data;
};

export const sendInvitation = async (userId: number) => {
  const url = `/users/invitation`;
  const response = await axios.post(url, { user_id: userId });
  return response.data;
};

export const getMysteryShopShoppers = async () => {
  const url = `/users/mystery_shop_request_shoppers`;
  const response = await axios.get(url);
  return response.data;
};

export const checkUser = async (params: any) => {
  const url = `/users/check`;
  const response = await axios.get(url, { params });
  return response.data;
};

export const getCmiDigestPreference = async () => {
  const url = `/users/cmi-digest`;
  const response = await axios.get(url);
  return response.data;
};

export const updateCmiDigestPreference = async (payload: any) => {
  const url = `/users/cmi-digest`;
  const response = await axios.put(url, payload);
  return response.data;
};

export const getCmiDigestCommunities = async () => {
  const url = `/users/cmi-digest/communities`;
  const response = await axios.get(url);
  return response.data;
};

export const getCmiDigestAdminUsers = async (params: any) => {
  const url = `/users/cmi-digest/admin`;
  const response = await axios.get(url, {
    params,
    paramsSerializer: {
      indexes: null,
    },
  });
  return response.data;
};

export const getCmiDigestAdminUserPreference = async (userId: number) => {
  const url = `/users/cmi-digest/admin/${userId}`;
  const response = await axios.get(url);
  return response.data;
};

export const updateCmiDigestAdminUserPreference = async (userId: number, payload: any) => {
  const url = `/users/cmi-digest/admin/${userId}`;
  const response = await axios.put(url, payload);
  return response.data;
};

export const getCmiDigestAdminUsersCommunities = async (userIds: number[]) => {
  const url = `/users/cmi-digest/admin/communities`;
  const response = await axios.get(url, { params: { user_ids: userIds.join(',') } });
  return response.data;
};

export const updateCmiDigestAdminUsersBulk = async (payload: any) => {
  const url = `/users/cmi-digest/admin/bulk`;
  const response = await axios.patch(url, payload);
  return response.data;
};
